<template>
  <el-dialog :visible.sync="modals" scrollable :title="title" class="order_box" width="1000">
    <el-form label-width="100px" @submit.native.prevent>
      <el-card :bordered="false" dis-hover class="i-table-no-border">
        <div class="ivu-description-list-title">退款信息</div>
        <el-row class="mb10">
          <el-col span="12">退款编号：{{ order_info.refundNo }}</el-col>
          <el-col span="12">订单编号：{{ order_info.order.ordersn }}</el-col>
        </el-row>
        <el-row class="mb10">
          <el-col span="12">实付金额：{{ order_info.order.payPrice }}元</el-col>
          <el-col span="12">退款金额：{{ order_info.price }}元</el-col>
        </el-row>
        <el-row class="mb10">
          <el-col span="12"
            >车费金额：{{ order_info.order.fare }}元<span v-if="order_info.order.isDepart != 0"
              >（不可退）</span
            ></el-col
          >
          <el-col span="12">扣除手续费：{{ order_info.serviceCharge }}元</el-col>
        </el-row>
        <el-row class="mb10">
          <el-col span="12">付款时间：{{ order_info.order.payTime }}</el-col>
          <el-col span="12"
            >付款方式：
            <el-tag color="default" v-if="order_info.order.payType == ''">未知方式</el-tag>
            <el-tag color="warning" v-else-if="order_info.order.payType == 'yue'">余额支付</el-tag>
            <el-tag color="primary" v-else-if="order_info.order.payType == 'alipay'">支付宝支付</el-tag>
            <el-tag color="success" v-else-if="order_info.order.payType == 'weixin'">微信支付</el-tag>
            <el-tag color="default" v-else>未知</el-tag>
          </el-col>
        </el-row>
        <el-row class="mb10">
          <el-col span="24">退款说明：{{ order_info.remark }}</el-col>
        </el-row>
        <el-divider direction="vertical"></el-divider>
        <div v-if="is_remark" class="ivu-description-list-title">退款处理</div>
        <el-row class="mb10" v-if="is_remark">
          <el-col span="24">
            <el-form-item label="处理结果：">
              <el-radio-group v-model="refund_status">
                <el-radio-button :label="-1">驳回申请</el-radio-button>
                <el-radio-button :label="20">同意退款</el-radio-button>
                <el-radio-button :label="30">已手动退款</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col span="24">
            <el-form-item label="驳回原因：" v-if="refund_status == -1">
              <el-input placeholder="请输入驳回原因" ref="input" v-model="reason" type="textarea"></el-input>
            </el-form-item>
            <div v-if="refund_status == 20">
              <el-alert type="warning" show-icon>
                微信支付方式： 会返回到相应的的支付渠道(如零钱或银行卡）<br /><br />如有余额抵扣： 会返回金额到用户余额
              </el-alert>
            </div>
            <div v-if="refund_status == 30">
              <el-lert type="warning" show-icon> 手动退款： 您用其他方式进行退款，订单会按完成退款处理。</el-lert>
            </div>
          </el-col>
          <!-- <Col span="24">
              <FormItem  label="驳回至：" v-if="refund_status == -1">
                  <RadioGroup v-model="order_status">
                      <Radio :label=0>待付款状态</Radio>
                      <Radio :label=10>待接单状态</Radio>
                      <Radio :label=20>已接单状态</Radio>
                      <Radio :label=30>已完成状态</Radio>
                  </RadioGroup>
              </FormItem>
          </Col> -->
        </el-row>
        <div v-if="!is_remark" class="ivu-description-list-title">退款详情</div>
        <el-row class="mb10" v-if="!is_remark">
          <el-col span="12">处理方式：{{ order_info.refundStatusName }}</el-col>
        </el-row>
      </el-card>
    </el-form>
    <div slot="footer">
      <el-button @click="cancel">关闭</el-button>
      <el-button v-if="is_remark" type="primary" @click="putSend" v-loading="send_locked">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getRefundInfo, refundOrder } from '@/api/order';

export default {
  name: 'orderRefund',
  props: {
    orderId: Number,
  },
  data() {
    return {
      order_info: [],
      remark_info: null,
      title: '订单退款',
      modals: false,
      is_remark: true,
      focus: false,
      reason: '',
      refund_status: 0,
      order_status: 0,
      send_locked: false,
    };
  },
  methods: {
    // 订单详情
    getOrderInfo() {
      getRefundInfo({ id: this.orderId })
        .then(async (data) => {
          this.order_info = data;
        })
        .catch((res) => {
          this.$message.error(res.msg);
        });
    },
    // 提交
    putSend() {
      if (this.send_locked) {
        return this.$message.error('请勿重复提交');
      }
      if (this.refund_status == -1 && this.reason == '') {
        return this.$message.error({
          message: '驳回原因不能为空',
          duration: 2000,
        });
      }
      if (this.refund_status == 0) {
        return this.$message.error({
          message: '请选择退款处理方式',
          duration: 2000,
        });
      }
      if (this.order_info.pay_type == '' && this.order_status !== 0) {
        return this.$message.error({
          message: '订单未支付，建议驳回至待付款状态',
          duration: 2000,
        });
      }
      let data = {
        orderId: this.orderId,
        refundStatus: this.refund_status,
        reason: this.reason,
        refundId: this.order_info.id,
      };
      this.send_locked = true;
      refundOrder(data)
        .then((res) => {
          this.$message.success({
            message: '处理成功',
            duration: 3000,
          });
          this.$emit('submitOk');
          let that = this;
          setTimeout(function () {
            that.modals = false;
            that.reset();
            that.send_locked = false;
          }, 3000);
        })
        .catch((res) => {
          this.send_locked = false;
          return this.$message.error({
            message: res.msg,
            duration: 2000,
          });
        });
    },
    cancel(name) {
      this.modals = false;
      this.reset();
      this.$emit('clearId');
    },
    reset() {
      this.refund_status = 0;
      this.reason = '';
      this.order_status = 0;
    },
  },
};
</script>

<style>
.ivu-description-list-title {
  margin-bottom: 20px;
  color: #17233d;
  font-weight: bold;
  font-size: 14px;
}
</style>
